import { Box, Flex, HStack, Text } from '@chakra-ui/react';
import { CloseIcon } from '@chakra-ui/icons';
import { PresetDoc } from '../redux/services/mixgenie';
import { presetGradient } from './PresetPicker';

/**
 * Chip row for the applied presets, matching the pictools "Selection" strip:
 * mini thumbnail + name + × button. Removal is one tap. Chips wrap so the
 * strip stays a single visual unit rather than growing horizontally.
 */
export function PresetChips({
  presets,
  onRemove,
}: {
  presets: PresetDoc[];
  onRemove: (id: string) => void;
}) {
  if (presets.length === 0) return null;
  return (
    <Flex wrap="wrap" gap={2}>
      {presets.map((p) => (
        <PresetChip key={String(p._id)} preset={p} onRemove={() => onRemove(String(p._id))} />
      ))}
    </Flex>
  );
}

function PresetChip({ preset, onRemove }: { preset: PresetDoc; onRemove: () => void }) {
  return (
    <HStack
      spacing={2}
      pl={1}
      pr={2}
      py={1}
      bg="whiteAlpha.100"
      borderWidth="1px"
      borderColor="whiteAlpha.300"
      borderRadius="full"
      _hover={{ borderColor: 'pink.400' }}
    >
      {preset.imageUrl ? (
        <Box boxSize="24px" borderRadius="full" bgImage={`url(${preset.imageUrl})`} bgSize="cover" bgPosition="center" flexShrink={0} />
      ) : (
        <Flex boxSize="24px" borderRadius="full" bgGradient={presetGradient(preset.gradient)} align="center" justify="center" flexShrink={0}>
          <Text fontSize="xs" lineHeight={1}>{preset.emoji || '🎵'}</Text>
        </Flex>
      )}
      <Text fontSize="sm" color="whiteAlpha.900" fontWeight={600} noOfLines={1}>
        {preset.name}
      </Text>
      <Box
        as="button"
        aria-label={`Remove ${preset.name}`}
        onClick={onRemove}
        boxSize="20px"
        borderRadius="full"
        display="flex"
        alignItems="center"
        justifyContent="center"
        color="whiteAlpha.600"
        _hover={{ color: 'pink.300', bg: 'whiteAlpha.200' }}
      >
        <CloseIcon boxSize="8px" />
      </Box>
    </HStack>
  );
}
